import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Auth from './components/Auth'; // Your Auth component
import GiftCards from './components/GiftCards'; // A new component to display gift cards
import Pay from './components/Pay';
import CheckoutPage from './components/Checkout';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="/gift-cards" element={<GiftCards />} />
        <Route path="/pay" component={Pay} />
        <Route path="/checkout" element={<CheckoutPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
